import { Component, Vue } from "vue-property-decorator";
import { User } from "../../models";
import { camelToUnderscore } from "@/utils/Typography";

export const GET_USERS = "get_users";
export const GET_USER = "get_user";
export const DESTROY_USER = "destroy_user";
export const CREATE_USER = "create_user";
export const UPDATE_USER = "update_user";

@Component
export default class UsersMixin extends Vue {
  readonly path = camelToUnderscore(User.type);
  readonly routes = this.$getModelRoutes("admin/users");

  getUsers(data: any) {
    console.log(data);
    return this.$httpGet(this.routes.indexUrl(data), GET_USERS);
  }

  getUser(id: number) {
    return this.$httpGet(this.routes.getUrl(`${id}`), GET_USER, "*");
  }

  destroyUser(id: number | string) {
    return this.$httpDelete(this.routes.deleteUrl(`${id}`), DESTROY_USER, null);
  }

  createUser(data: User) {
    return this.$httpPost(this.routes.createUrl(), CREATE_USER, data);
  }

  updateUser(data: User) {
    return this.$httpPut(this.routes.updateUrl(data.id), UPDATE_USER, data);
  }
}
